document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.card-swatches__link');
  if (!swatch) return;

  event.preventDefault();

  const imageUrl = swatch.dataset.imageUrl;
  const variantUrl = swatch.dataset.variantUrl;
  const cardWrapper = swatch.closest('.card-wrapper');
  if (!cardWrapper) return;

  if (imageUrl) {
    cardWrapper.querySelectorAll('.card__media img').forEach((img) => {
      img.removeAttribute('srcset');
      img.src = imageUrl;
    });
  }

  if (variantUrl) {
    cardWrapper.querySelectorAll('a[href*="/products/"]').forEach((link) => {
      link.href = variantUrl;
    });
  }

  const swatchGroup = swatch.closest('.card-swatches');
  swatchGroup?.querySelectorAll('.card-swatches__link').forEach((link) => link.classList.remove('is-active'));
  swatch.classList.add('is-active');
});
